import { GraphQLError } from 'graphql';
import React, { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '@sbu/components.button';
import { ErrorState, ErrorType } from '@sbu/components.errorstate';

import { isGraphQLNotFoundError } from 'shared/components/utils/ErrorBoundary';

export interface ErrorProps {
  children?: ReactNode;
  graphQLError?: ReadonlyArray<GraphQLError>;
  type?: ErrorType | undefined;
}

export const Error = ({ children, graphQLError, type }: ErrorProps) => {
  const history = useHistory();

  const isAccessedDirectly = !history?.length || history.length <= 2;

  const handleClick = () => {
    isAccessedDirectly ? history.push('/') : history.goBack();
  };

  const errorType =
    type ?? (isGraphQLNotFoundError(graphQLError?.[0]) ? 'notFound' : 'server');

  return (
    <ErrorState type={errorType}>
      {children}
      {errorType !== 'client' && (
        <Button onClick={handleClick}>
          {isAccessedDirectly ? 'Go Home' : 'Back to Previous Page'}
        </Button>
      )}
    </ErrorState>
  );
};

export default Error;
